import { render, staticRenderFns } from "./addMaterials.vue?vue&type=template&id=6c7ec190&"
import script from "./addMaterials.vue?vue&type=script&lang=js&"
export * from "./addMaterials.vue?vue&type=script&lang=js&"
import style0 from "./addMaterials.vue?vue&type=style&index=0&id=6c7ec190&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports